import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { CrmThemePalette } from '@shared/core/types';

export type Padding = 'horizontal' | 'vertical' | boolean;

@Component({
  selector: 'crm-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContainerComponent implements OnInit, OnChanges {
  @Input() padding: Padding = true;
  @Input() color: CrmThemePalette;
  @Input() class?: string;

  @HostBinding('class') classes = '';

  ngOnInit(): void {
    this.setClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const isFirstChange = Object.values(changes).some(c => c.isFirstChange());

    if (!isFirstChange) {
      this.setClasses();
    }
  }

  private setClasses(): void {
    const cssClasses: string[] = [];

    if (this.class) {
      cssClasses.push(this.class);
    }

    if (this.padding === true) {
      cssClasses.push('-padding');
    } else if (this.padding === 'horizontal') {
      cssClasses.push('-padding-horizontal');
    } else if (this.padding === 'vertical') {
      cssClasses.push('-padding-vertical');
    }

    if (this.color) {
      cssClasses.push(`-${this.color}`);
    }

    this.classes = cssClasses.join(' ');
  }
}
